const BASE_URL = "https://zoeil.yanisallali.com/wp-json/wp/v2";

const CONTACT_URL = "https://zoeil.yanisallali.com/wp-json/contact-form/v1";

function decodeHtmlEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

function stripHtmlTags(htmlString) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  const wrapParagraphs = (htmlString) => {
    // Diviser la chaîne par double saut de ligne (indicateur de fin de paragraphe)
    const paragraphs = htmlString.split('\r\n\r\n');
    
    // Entourer chaque paragraphe avec des balises <p> et les joindre en une seule chaîne
    return paragraphs
      .map(paragraph => `<p>${paragraph}</p>`)
      .join('');
  };
  

export {BASE_URL, decodeHtmlEntities, stripHtmlTags, wrapParagraphs, CONTACT_URL};